import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { SessionOut } from '@components/sessionOutDialog/SessionOut';

export const ManagerLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tenantId = location.pathname.split('/')[2];

  const handleCloseSessionOut = () => {
    navigate(`/manager/${tenantId}/login`, { state: { routeAfterLogin: location.pathname, tenantId } });
  };

  return (
    <>
      <Outlet />
      <SessionOut onClose={handleCloseSessionOut} />
    </>
  );
};
